import _ from 'lodash';
import Store from './Store'; 
import { buildModels } from '../libraries/graphql';
import { gql } from 'apollo-boost';

export default class Story extends Store { 

  constructor(props) {
    super(props); 
    this.set(props); 
    return this.setup();
  }

  static schema = {
    Story: {
      normalizeAs: 'Story',
      primaryKey: '_id',
      fields: {
        title: String,
        blurb: String,
        draftId: String, 
        templateId: String, 
        draft: 'Draft', 
        template: 'Template',
        participants: ['User'],
        // parents: ["DraftParent"],
        // participants: ["User"],
        // sessions: ["DraftSession"],
        fields: {},
        createdBy: String,
        updatedBy: String,
        image: String,
        _id: String,
        updatedAt: Date,
        createdAt: Date,
      },
    },
  }

  set(...args) {
    let changes = {}; 

    // Has an object for first value, just set the object 
    if (_.isObject(args[0])) {
      changes = _.clone(args[0]);
    }

    // Has a string first value, most probably a key value pair
    if (_.isString(args[0])) {
      changes = {
        [args[0]]: args[1]
      }
    }

    // console.log(changes.draft);

    // if (changes.draft) {
    //   changes.draft.store$.subscribe((draft) => {

    //     if (draft && draft.sessions.length) {
    //       const fields = this.flattenDraftSessionFields(draft);
    //       console.log(fields);
    //     }
    //   });
    // }

    if (changes.sessions) {
      _.assign(changes, this.flattenDraftSessionFields(changes));
    }

  //  _.reduce(changes, (acc, val, key) => {
  //     _.assign(acc, {[key]: val});
    
  //     if (key === 'draft') {
  //       console.log(val);

  //       const obj = val.toObject()

  //       console.log(obj);


  //       const fields = _.map(obj.sessions, 'fields')
  //       console.log(fields);
  //     }

  //     if (key === 'template') {
  //       console.log(val);
  //     }
  //     return acc; 
  //  }, {})

   console.log('Setting story changes', changes, this.store); 

    return Store.prototype.set.call(this, changes)
  }

  flattenDraftSessionFields(draft) {
    if (!(draft && draft.sessions.length)) {
      return {};
    }

    const fields = draft.sessions.reduce((acc, curr) => {
      if (curr.fields) {
        _.assign(acc, curr.fields);

        Object.entries(curr.fields)
          .filter(([key, val]) => /story_/.test(key))
          .forEach(([key, val]) => _.assign(acc, {
            [key.replace('story_', '')]: val
          }));
      }
      return acc; 
    }, {});

    return fields; 
  }
  
  async syncCreate() {
    return (({ models, mutate, client }) => {
      const { Story } = models;
      return new Promise((resolve, reject) => mutate(
        Story('storyCreateOne', this.serialize()).only(['_id'])
      ).generate(gqlStr => {
        console.log('Story:syncCreate:generate graphql string', gqlStr);
        resolve(client.mutate({
          mutation: gql(gqlStr)
        }).then(({data}) => {
          console.log('Done story syncCreate',data.storyCreateOne);
          this.set(data.storyCreateOne);
        }));
      }));
    })(Story.gql);
  }

  getField(field) {
    if (!this.store.sessions) {
      return '';
    }

    let value = '';

    const obj = this.toObject();

    console.log('Before getting value', obj); 

    if (obj[field]) {
      return obj[field]; 
    }

    _.forEach(obj.sessions, (session) => {
      if (session.fields[field]) {  
        value = session.fields[field];
      }
    });

    console.log('After getting value', obj, value);

    return value; 

  }

  serialize() {
    function checkVal(objVal, srcVal, key, obj, source) {
      if (!objVal) {
        return null; 
      }
 
      if (!srcVal) {
        return objVal;
      }

      if (srcVal === 'Template') {
        obj['templateId'] = objVal._id; 
        return objVal._id; 
      }
      if (srcVal === 'Draft') {
        obj['draftId'] = objVal._id;
        return objVal._id;
      }

      if (key === 'createdBy') {
        return objVal._id; 
      }

      if (key === 'participants') {
        return _.compact((objVal || []).map(p => p._id));
      }

      if (_.isArray(srcVal)) {
        return objVal.map(o => checkVal(o, srcVal[0], key, obj, source));
      }
 
      return objVal;  
    }
    const castedObject = _.omit(_.assignWith(this.toObject(), Story.schema.Story.fields, checkVal), ['parents', 'sessions','prompts','_id', 'createdAt']);

    console.log('Casted Story object', castedObject);

    const result = _.pick(castedObject, ['blurb', 'title', 'image', 'createdBy']);
    _.assign(result, {
      draftId: castedObject.draft,
      templateId: castedObject.template,
      participants: castedObject.participants,
      fields: _.omit(castedObject, _.keys(Story.schema.Story.fields).concat(['__typename', 'parents', 'sessions', '_id', 'createdAt'])),
    });

    console.log('Final results', result); 

    return result;
  }
}

buildModels(Story);





// WEBPACK FOOTER //
// ./src/models/Story.js